module.exports = __webpack_public_path__ + "static/media/preview.6befd188.png";